import { render } from "./BackButtonComponent.vue?vue&type=template&id=a86b3d42&ts=true"
import script from "./BackButtonComponent.vue?vue&type=script&lang=ts"
export * from "./BackButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__